/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { RM1, RM1Interface } from "../RM1";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IARC",
        name: "arc_",
        type: "address",
      },
      {
        internalType: "address",
        name: "provider_",
        type: "address",
      },
      {
        internalType: "address",
        name: "defaultFtsoProvider_",
        type: "address",
      },
      {
        internalType: "contract IVPToken",
        name: "vpToken_",
        type: "address",
      },
      {
        internalType: "contract IFtsoManager",
        name: "ftsoManager_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ArcNft",
    outputs: [
      {
        internalType: "contract IARC",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_VPRANGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VALIDREWARDEPOCH",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WNat",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_ftsoManager_",
    outputs: [
      {
        internalType: "contract IFtsoManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "rewardEpoch",
        type: "uint32",
      },
    ],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "rewardEpoch",
        type: "uint32",
      },
    ],
    name: "claimable",
    outputs: [
      {
        internalType: "bool",
        name: "isClaimable",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "rewardEpoch",
        type: "uint32",
      },
    ],
    name: "claimableId",
    outputs: [
      {
        internalType: "uint32",
        name: "id",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "claimedStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultFtsoProvider",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "firstRewardEpoch",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "flipPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoManager",
    outputs: [
      {
        internalType: "contract IFtsoManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "ftsoWhitelist",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getClaimableEpochs",
    outputs: [
      {
        internalType: "uint32[]",
        name: "claimableEpochs",
        type: "uint32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "provider",
        type: "address",
      },
      {
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardEpoch",
        type: "uint256",
      },
    ],
    name: "getDelegatedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMinOfOrder",
    outputs: [
      {
        internalType: "uint256",
        name: "min",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "index",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "orderer",
        type: "address",
      },
    ],
    name: "getOrderable",
    outputs: [
      {
        internalType: "bool",
        name: "orderable",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRandomFtsoProvider",
    outputs: [
      {
        internalType: "address",
        name: "randomAssignedFtsoProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "randomUpcomingFtsoProvider",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "epoch",
        type: "uint32",
      },
    ],
    name: "getRank",
    outputs: [
      {
        internalType: "uint32",
        name: "rank",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_epoch",
        type: "uint32",
      },
      {
        internalType: "uint32[]",
        name: "_rankArray",
        type: "uint32[]",
      },
    ],
    name: "getRankInfoes",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "_rank",
            type: "uint32",
          },
          {
            internalType: "address",
            name: "_delegator",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_amount",
            type: "uint256",
          },
        ],
        internalType: "struct ArcNFTRewardManager.RankingItem[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_epoch",
        type: "uint32",
      },
    ],
    name: "getRewardARCOrdersCount",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "intervalEpochsForRandomFtso",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lowerboundOfVPRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintableRankThres",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "order",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "orderAddresses",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "orderAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "orders",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "provider",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    name: "rankStore",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rankThres",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_defaultProvider",
        type: "address",
      },
    ],
    name: "setDefaultFtsoProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_epochId",
        type: "uint32",
      },
    ],
    name: "setFirstRewardEpoch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IFtsoManager",
        name: "ftsoManager_",
        type: "address",
      },
    ],
    name: "setFtsoManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_ftsoWhitelist",
        type: "address[]",
      },
    ],
    name: "setFtsoWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_intervalEpochs",
        type: "uint32",
      },
    ],
    name: "setIntervalEpochsForRandomFtso",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_mintableRankThres",
        type: "uint32",
      },
    ],
    name: "setMintableRankThres",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IARC",
        name: "_arc",
        type: "address",
      },
    ],
    name: "setNFTContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_provider",
        type: "address",
      },
    ],
    name: "setProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "rankThres_",
        type: "uint32",
      },
    ],
    name: "setRankThres",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "threshold_",
        type: "uint256",
      },
    ],
    name: "setThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_lowerValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_upperValue",
        type: "uint256",
      },
    ],
    name: "setVPRange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVPToken",
        name: "vpToken_",
        type: "address",
      },
    ],
    name: "setVpToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_WNat",
        type: "address",
      },
    ],
    name: "setWNat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startRewardEpochForRandomFtso",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "switchFtsoDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "threshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "upperboundOfVPRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vpFtsoDistribution",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type RM1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RM1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RM1__factory extends ContractFactory {
  constructor(...args: RM1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    arc_: PromiseOrValue<string>,
    provider_: PromiseOrValue<string>,
    defaultFtsoProvider_: PromiseOrValue<string>,
    vpToken_: PromiseOrValue<string>,
    ftsoManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<RM1> {
    return super.deploy(
      arc_,
      provider_,
      defaultFtsoProvider_,
      vpToken_,
      ftsoManager_,
      overrides || {}
    ) as Promise<RM1>;
  }
  override getDeployTransaction(
    arc_: PromiseOrValue<string>,
    provider_: PromiseOrValue<string>,
    defaultFtsoProvider_: PromiseOrValue<string>,
    vpToken_: PromiseOrValue<string>,
    ftsoManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      arc_,
      provider_,
      defaultFtsoProvider_,
      vpToken_,
      ftsoManager_,
      overrides || {}
    );
  }
  override attach(address: string): RM1 {
    return super.attach(address) as RM1;
  }
  override connect(signer: Signer): RM1__factory {
    return super.connect(signer) as RM1__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RM1Interface {
    return new utils.Interface(_abi) as RM1Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): RM1 {
    return new Contract(address, _abi, signerOrProvider) as RM1;
  }
}
